import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Star } from 'lucide-react';

const TestimonialModal = ({ 
  isOpen, 
  onClose, 
  onSave, 
  testimonial = null, 
  loading = false 
}) => {
  const [formData, setFormData] = useState({
    name: testimonial?.name || '',
    text: testimonial?.text || '',
    rating: testimonial?.rating || 5,
    image: testimonial?.image || '',
    location: testimonial?.location || '',
    carPurchased: testimonial?.carPurchased || '',
    isActive: testimonial?.isActive !== undefined ? testimonial.isActive : true
  });

  const handleSave = () => {
    if (!formData.name || !formData.text) {
      return;
    }

    const testimonialData = {
      ...formData,
      rating: parseInt(formData.rating) || 5
    };

    onSave(testimonialData);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-gray-900 text-white border-amber-500/20 max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-amber-400">
            {testimonial ? 'עריכת המלצה' : 'הוספת המלצה חדשה'}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2">שם הלקוח*</label>
              <Input
                value={formData.name}
                onChange={(e) => setFormData(prev => ({...prev, name: e.target.value}))}
                placeholder="יוסי כהן"
                className="bg-gray-700 border-gray-600 text-white"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-2">מיקום</label>
              <Input
                value={formData.location}
                onChange={(e) => setFormData(prev => ({...prev, location: e.target.value}))}
                placeholder="תל אביב"
                className="bg-gray-700 border-gray-600 text-white"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">טקסט ההמלצה*</label>
            <Textarea
              value={formData.text}
              onChange={(e) => setFormData(prev => ({...prev, text: e.target.value}))}
              placeholder="שירות מעולה, צוות מקצועי ואמין..."
              className="bg-gray-700 border-gray-600 text-white min-h-[120px]"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2">דירוג</label>
              <Select 
                value={formData.rating.toString()} 
                onValueChange={(value) => setFormData(prev => ({...prev, rating: parseInt(value)}))}
              >
                <SelectTrigger className="bg-gray-700 border-gray-600 text-white">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-gray-800 border-gray-600">
                  {[1,2,3,4,5].map(rating => (
                    <SelectItem key={rating} value={rating.toString()} className="text-white">
                      <div className="flex items-center gap-1">
                        {Array.from({length: rating}).map((_, i) => (
                          <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                        ))}
                        <span className="mr-2">{rating} כוכבים</span>
                      </div>
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-2">רכב שנרכש</label>
              <Input
                value={formData.carPurchased}
                onChange={(e) => setFormData(prev => ({...prev, carPurchased: e.target.value}))}
                placeholder="BMW X5 2022"
                className="bg-gray-700 border-gray-600 text-white"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">תמונת הלקוח</label>
            <Input
              value={formData.image}
              onChange={(e) => setFormData(prev => ({...prev, image: e.target.value}))}
              placeholder="קישור לתמונת הלקוח"
              className="bg-gray-700 border-gray-600 text-white"
            />
          </div>

          <div className="flex gap-4 pt-4">
            <Button
              onClick={handleSave}
              disabled={loading || !formData.name || !formData.text}
              className="bg-amber-500 hover:bg-amber-600 text-black flex-1"
            >
              {loading ? 'שומר...' : testimonial ? 'עדכן המלצה' : 'הוסף המלצה'}
            </Button>
            <Button
              onClick={onClose}
              variant="outline"
              className="border-gray-600 text-white hover:bg-gray-700"
            >
              ביטול
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TestimonialModal;